import { faCheck, faX } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Colors, Flex, Text } from '@pinchenterprisesnpm/friday-ui'
import {
  InfoParagraph,
  InfoSubsectionContainer,
} from '@src/features/shift-post-v2/steps/shift-details-step/components/position-name-section/components/info-subsection/info-subsection.style'

interface IInfoSubsectionProps {
  content?: string
  title: string
  showFullDescription: boolean
  showCheckmark?: boolean
  isRequired?: boolean
}

export const InfoSubsection = ({
  content,
  title,
  showFullDescription,
  showCheckmark = true,
  isRequired,
}: IInfoSubsectionProps) => {
  const Container = showFullDescription || !content ? Box : InfoSubsectionContainer
  const showCheckMarkFinal = showCheckmark && content
  const showXFinal = !showCheckmark && isRequired

  return (
    <Container {...(showFullDescription && { mt: 'sm' })}>
      <Flex alignItems='center'>
        {showCheckMarkFinal && <FontAwesomeIcon icon={faCheck} color={Colors.success} />}
        {showXFinal && <FontAwesomeIcon icon={faX} color={Colors.danger} />}
        {!showCheckMarkFinal && !showXFinal && <Box width='12px' />}
        <Text fontSize='medium' ml='sm' my={0}>
          {title}
        </Text>
      </Flex>

      {content && (
        <InfoParagraph
          dangerouslySetInnerHTML={{
            __html: content,
          }}
          style={{
            marginLeft: '21px',
          }}
        />
      )}
    </Container>
  )
}
